declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return

  const n: any = (window.fbq = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as unknown[][]

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = document.getElementsByTagName('script')[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', '1480429390272161')
  window.fbq('track', 'PageView')

  // noscript fallback
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src =
    'https://www.facebook.com/tr?id=1480429390272161&ev=PageView&noscript=1'
  document.body.appendChild(img)
}

export function trackAddToCart(e: React.MouseEvent<HTMLAnchorElement>): void {
  const href = e.currentTarget.href

  if (typeof window !== 'undefined' && window.fbq) {
    // Prevent immediate navigation so the pixel event has time to fire
    e.preventDefault()

    window.fbq('track', 'AddToCart', {
      content_name: 'Competir sin Miedo',
      content_type: 'product',
      value: 17.99,
      currency: 'EUR',
    })

    // Allow 300ms for the pixel to send, then navigate
    setTimeout(() => {
      window.location.href = href
    }, 300)
  }
}
